/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { ThumbsDownCheckCheckedAt } from './thumbsDownCheckCheckedAt';
import type { ThumbsDownCheckDraft } from './thumbsDownCheckDraft';
import type { ThumbsDownCheckObservation } from './thumbsDownCheckObservation';
import type { ThumbsDownCheckNextStep } from './thumbsDownCheckNextStep';

export interface ThumbsDownCheck {
  reason: string;
  votedAt: string;
  checkedAt?: ThumbsDownCheckCheckedAt;
  draft?: ThumbsDownCheckDraft;
  observation?: ThumbsDownCheckObservation;
  nextStep?: ThumbsDownCheckNextStep;
}
